import React, { useEffect, useState } from 'react'
import ReactModal from 'react-modal'
import axios from 'axios'
//impoertacion componentes
import * as IoIcons from 'react-icons/io';
import { obtenerUsuarioEducacion } from '../Services/Rest';
import Swal from 'sweetalert2';


function EditarRegional(props) {



    const [modalIsOpen, setIsOpen] = useState(false);
    const handleOpenModalTest = () => {
        setIsOpen(true);
    };
    const closeModal = () => {
        setIsOpen(false);
    };


    const [usuarios, setUsuarios] = useState([]);
    useEffect(() => {
        axios({
            auth: { username: 'webapp', password: '762tsfsy9826kk87ytttsf' },
            method: 'get',
            url: obtenerUsuarioEducacion
        })
            .then((Response) => {
                setUsuarios(Response.data);
                console.log(Response.data)
            }).catch((error) => {
                console.log(error)
            })
    }, [setUsuarios]);
    const [postDescripcion, setPostDescipcion] = useState([]);
    const [postCorreo, setPostCorreo] = useState([]);
    const postData = e => {
        e.preventDefault(e)

        axios({
            auth: { username: 'webapp', password: '762tsfsy9826kk87ytttsf' },
            method: 'put',
            url: "https://educacionapi.azurewebsites.net/api/ActualizaGestorRegional?Id=" + props.idRegional,
            data: {
                descripcion: postDescripcion,
                correo: postCorreo
            }
        })
            .then((Response) => {
                console.log(Response.data)
                window.location.reload("/")
                Swal.fire({
                    title: 'Actualizado con exito!',
                    text: 'Añadido.',
                    icon: 'warning',
                    timer: 3500
                });

            }).catch((error) => {
                Swal.fire({
                    title: 'Error en los campos',
                    text: 'Intente de nuevo.',
                    icon: 'warning',
                    timer: 3500
                });
            })


    };
    return (
        <div className="test">
            <button variant="contained" className='btn btn-warning' onClick={handleOpenModalTest} > <IoIcons.IoIosSearch /></button>
            <ReactModal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                contentLabel="Crear Institucion">


                <div className="container">
                    <div className="text-center">
                        <div class="container-fluid">
                            <div class="card shadow mb-4">
                                <div class="card-header py-3">
                                    <h6 class="m-0 font-weight-bold text-primary">Actualizar Regional</h6>
                                </div>
                                <div class="card-body">
                                    <div class="table-responsive"></div>
                                    <form className="user">
                                        <div className="form-group row">

                                            <div className="col-sm-6 mb-3 mb-sm-0">
                                                <select className='btn btn-secondary btn-user btn-block' onChange={(e) => setPostDescipcion(e.target.value)}>
                                                    <option value=''>Seleccione Nombre del Gestor</option>
                                                    {usuarios.map((item) => (
                                                        <option value={item.nombre}>{item.nombre}</option>
                                                    ))
                                                    }
                                                </select>
                                            </div>
                                            <div className="col-sm-6">
                                                <select className='btn btn-secondary btn-user btn-block' onChange={(e) => setPostCorreo(e.target.value)}>
                                                    <option value=''>Seleccione Correo del Gestor</option>
                                                    {usuarios.map((item) => (
                                                        <option value={item.correo}>{item.correo}</option>
                                                    ))
                                                    }
                                                </select>
                                            </div>
                                        </div>


                                        <hr />
                                        <a ><button className="btn btn-primary btn-user btn-block " onClick={postData}>Guardar</button></a>


                                        <hr />
                                    </form>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ReactModal>

        </div>
    )
}
export default EditarRegional;
